import React from 'react';
import { useT } from '../../i18n/useT';
import './ProblemSolution.css';

const PROBLEM_ICONS = ['📁', '🔍', '🗂️', '📧'];
const SOLUTION_ICONS = ['⚡', '🎯', '🏷️', '🔒'];

export default function ProblemSolution() {
  const t = useT();
  const ps = t.problemSolution;

  return (
    <section className="problem-solution section" aria-labelledby="ps-heading">
      <div className="container">
        <div className="section-header">
          <div className="badge badge-gray">{ps.badge}</div>
          <h2 id="ps-heading" style={{ marginTop: 'var(--space-4)' }}>
            {ps.headline}
          </h2>
          <p>{ps.sub}</p>
        </div>

        <div className="ps__grid">
          <div className="ps__column ps__column--problem">
            <div className="ps__column-header">
              <div className="ps__column-badge ps__column-badge--red">{ps.before}</div>
            </div>
            <div className="ps__items">
              {ps.problems.map((text, i) => (
                <div key={i} className="ps__item ps__item--problem">
                  <span className="ps__item-icon" aria-hidden="true">{PROBLEM_ICONS[i]}</span>
                  <span>{text}</span>
                  <div className="ps__item-x" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M2 2l10 10M12 2L2 12" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="ps__arrow" aria-hidden="true">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="19" stroke="var(--color-primary-200)" strokeWidth="2"/>
              <path d="M15 20h10M21 16l4 4-4 4" stroke="var(--color-primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <div className="ps__column ps__column--solution">
            <div className="ps__column-header">
              <div className="ps__column-badge ps__column-badge--green">{ps.after}</div>
            </div>
            <div className="ps__items">
              {ps.solutions.map((text, i) => (
                <div key={i} className="ps__item ps__item--solution">
                  <span className="ps__item-icon" aria-hidden="true">{SOLUTION_ICONS[i]}</span>
                  <span>{text}</span>
                  <div className="ps__item-check" aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M2.5 7l3 3 6-6" stroke="#10B981" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
